import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {Tooltip} from "primereact/tooltip";

import SafetyeducationListService from "../../services/safetyeducation/SafetyeducationListService";
import SafetyeducationDeleteService from "../../services/safetyeducation/SafetyeducationDeleteService";
import moment from "moment";

const SafetyeducationListComponent = (props) => {

  const [safetyeducation, setSafety] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(10);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1
  });
  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      window.App.setState({rerenderSafetyeducationList: false})
      SafetyeducationListService(JSON.stringify(lazyParams))
        .then(response => {
          setTotalRecords(response.data.total_item_count);
          setSafety(response.data.items);
          setLoading(false);
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: 10, value: 10},
        {label: 20, value: 20},
        {label: 50, value: 50},
        {label: 200, value: 200}
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };
  const deleteSafety = (rowData) => {
    SafetyeducationDeleteService(rowData.id)
      .then(response => {
        window.App.toastShow('success', 'Sikeres törlés!',);
        loadLazyData();
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      })
  }
  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {localStorage.getItem('roles').toString().includes('role_occ_safety_edu_write') &&
        // [rowData.closed !== true ? (
          <Button icon="pi pi-pencil" className="p-button-sm  p-button-warning p-mr-2"
                  tooltip="Módosítás"
                  onClick={() => {
                    window.App.setState({
                      sidebarSafetyeducationUpdate: true,
                      props: rowData
                    })
                  }}/>
        // ) : (
        //   <Button icon="pi pi-pencil" className=" p-button-warning p-mr-2 disabled"  />
        // )]
        }
        {localStorage.getItem('roles').toString().includes('role_occ_safety_edu_participants') &&
        <Button icon="pi pi-user" className="p-button-sm p-button-warning p-mr-2"
                tooltip="Résztvevők"
                onClick={() => {
                  window.App.setState({
                    sidebarSafetyeducationParticipants: true,
                    props: rowData
                  })
                }}/>
        }

        {localStorage.getItem('roles').toString().includes('role_occ_safety_edu_results') &&
        <Button icon="pi pi-check" className="p-button-sm  p-button-warning p-mr-2"
                tooltip="Eredmények"
                onClick={() => {
                  window.App.setState({
                    sidebarSafetyeducationResults: true,
                    props: rowData
                  })
                }}/>
        }
        {/*{localStorage.getItem('roles').toString().includes('role_occ_safety_edu_write') &&*/}
        {/*<Button icon="pi pi-trash" className=" p-button-danger"*/}
        {/*        tooltip="Törlés"*/}
        {/*        onClick={() => {*/}
        {/*          if (window.confirm('A törlés megerősítésére van szükség!')) {*/}
        {/*            deleteSafety(rowData)*/}
        {/*          }*/}
        {/*        }}*/}
        {/*/>*/}
        {/*}*/}
      </React.Fragment>
    );
  }

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderSafetyeducationList === true])

  return (

    <DataTable
      emptyMessage="Nincs találat."
      value={safetyeducation} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
      onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
      onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
      paginatorTemplate={pager} rows={rows} emptyMessage="Nincs találat."
      autoLayout={true}
      filterDisplay="row"
responsiveLayout="scroll"
      stripedRows
    >
      <Column body={actionBodyTemplate} className={"p-py-0 p-text-nowrap"}></Column>
      <Column field="name" header="Név" sortable filter filterPlaceholder="Név"></Column>
      <Column field="location" header="Helyszín" sortable filter filterPlaceholder="Helyszín"></Column>
      <Column field="date" header="Időpont" sortable
              body={(rowData) => {
                  return (
                    <>{moment.utc(rowData.date).local().format('YYYY-MM-DD HH:mm')}</>
                  )
              }}
      ></Column>
      {/*<Column field="entryLocationName" header="Projekt" sortable filter filterPlaceholder="Név"></Column>*/}
      <Column field="code" header="Kód" sortable filter filterPlaceholder="Kód"></Column>
    </DataTable>

  )
}
export default withTranslation('common')(SafetyeducationListComponent);
